var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleLoginline = function SvgGoogleLoginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M25.48 13.295c0-.921-.083-1.808-.236-2.659H13v5.029h6.996a5.98 5.98 0 0 1-2.594 3.924v3.261h4.202c2.458-2.263 3.876-5.596 3.876-9.555",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M13 26c3.51 0 6.453-1.164 8.604-3.15l-4.202-3.261c-1.164.78-2.653 1.24-4.402 1.24-3.386 0-6.252-2.286-7.274-5.359H1.383v3.368A13 13 0 0 0 13 26",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M5.726 15.47A7.8 7.8 0 0 1 5.318 13c0-.857.148-1.69.408-2.47V7.162H1.383A13 13 0 0 0 0 13c0 2.098.502 4.083 1.383 5.838z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M13 5.17c1.909 0 3.622.656 4.97 1.945l3.728-3.73C19.447 1.289 16.504 0 13 0A13 13 0 0 0 1.383 7.162l4.343 3.368C6.748 7.457 9.614 5.17 13 5.17",
    clipRule: "evenodd"
  })));
};
export default SvgGoogleLoginline;